var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBath = function SvgBath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.86 6.86c.39-.39.92-.61 1.473-.61h3.75v2.5a1.25 1.25 0 0 0 2.5 0V5c0-.69-.56-1.25-1.25-1.25h-5A4.584 4.584 0 0 0 8.75 8.333V18.75H6.667a2.917 2.917 0 0 0-2.917 2.917v5a7.92 7.92 0 0 0 2.892 6.117l-1.015 1.523a1.25 1.25 0 1 0 2.08 1.386l1.097-1.645c.904.35 1.874.535 2.863.535h16.666c.989 0 1.959-.185 2.863-.535l1.097 1.645a1.25 1.25 0 0 0 2.08-1.386l-1.015-1.523a7.917 7.917 0 0 0 2.892-6.117v-5a2.917 2.917 0 0 0-2.917-2.917H11.25V8.333c0-.552.22-1.082.61-1.473M6.667 21.25a.417.417 0 0 0-.417.417v5a5.416 5.416 0 0 0 5.417 5.416h16.666a5.417 5.417 0 0 0 5.417-5.416v-5a.417.417 0 0 0-.417-.417z",
    clipRule: "evenodd"
  })));
};
export default SvgBath;